module.exports = __webpack_public_path__ + "img/plan-family-mobile.ece01a9.png";